<template>
  <div id="plan-usage">
    <v-card elevation="2" class="pa-6" height="321px">
      <div class="heading font--secondary text-h5-heading font-weight-600">
        Plan Usage
      </div>

      <v-radio-group
        v-model="selectedProduct"
        hide-details
        class="mt-0 pt-6"
        @change="updateProduct"
      >
        <template v-for="plan in plans">
          <v-radio
            v-if="plan.isVisible && (hasMarketingAccess || hasServiceAccess)"
            outlined
            :ripple="false"
            color="#03B6FC"
            :key="plan.value"
            :label="plan.label"
            :value="plan.value"
            :class="radioClass"
            class="account-plan--radio mb-4"
          >
            <template v-slot:label>
              <div class="text--primary body-1 text-capitalize">
                {{ plan.label }}
              </div>
            </template>
          </v-radio>
        </template>
      </v-radio-group>
    </v-card>
  </div>
</template>

<script>
import constants from "@core/config/constants.js";
import { replaceUnderscore } from "@core/config/utils.js";
import { mapGetters } from "vuex";
const { MAROPOST_PRODUCTS } = constants;

export default {
  name: "AccountPlans",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    product: { type: String, default: "", required: true },
    packageTypes: { type: Object, default: () => ({}), required: true }
  },
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      selectedProduct: "",
      plans: [], 
    };
  },
  /**
  |--------------------------------------------------
  | Watchers
  |--------------------------------------------------
  */
  watch: {
    packageTypes:{
      handler() {
        this.getPlans();
      },
      immediate: true,
      deep: true
    },
    product: {
      handler(val) {
        this.selectedProduct = val;
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      defaultAccount: "auth/account",
      currentAccount: "auth/account.current",
    }),
    hasMarketingAccess(){
      return this.currentAccount.enable_marketing;
    },
    hasServiceAccess(){
      return this.currentAccount.enable_service
    },
    radioClass() {
      const visiblePlans = this.plans.filter(({ isVisible }) => isVisible);
      return visiblePlans.length < 2 ? "visible" : "";
    },
  },
  mounted() {
    this.getPlans(); 
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    updateProduct(product) {
      this.$emit("update-product", product);
    },
    productLabel(product, key) {
      if (this.packageTypes && this.packageTypes[key]) {
        return `${product.split("_")[0]} ${replaceUnderscore(
          this.packageTypes[key]
        )}`;
      } else {
        return `${product.split("_")[0]}`;
      }
    },
    getPlans() {
      const { current } = this.defaultAccount;
      this.plans = Object.entries(MAROPOST_PRODUCTS).map(([key, value]) => {
        return {
          label: this.productLabel(value, key),
          value,
          isVisible:
            MAROPOST_PRODUCTS.marketingCloud === value
              ? current.enable_marketing
              : current.enable_service
        };
      });
    }
  },
};
</script>

<style lang="scss">
.account-plan--radio {
  border-radius: 4px !important;
  border: 1px solid var(--on-light-surface-outlined-38, rgba(0, 0, 0, 0.38));
  border-radius: 12px;

  &.visible {
    .v-label {
      cursor: default;
      margin-left: 12px;
    }
    .v-input--selection-controls__input {
      display: none;
    }
  }
  .v-label {
    width: 344px;
    padding: 16px;
  }
  .v-input--selection-controls__input {
    padding-left: 16px;
  }
}
</style>